export default __webpack_public_path__ + "static/img-what-is-ml--mobile-7bed32108f1b4b630608e240ffec1141.png";